import { Box, Grid, Link, Typography } from '@mui/material';
import Image from 'next/image';

// import moment from 'moment';
// import { useState } from 'react';

const BlogContent = () => {
  // const router = useRouter();
  // const [blogItems, setBolgItems] = useState<any[]>([]);
  // async function fetchData() {
  //   await fetch(
  //     'https://api.rss2json.com/v1/api.json?rss_url=https://blog.taxzerone.com/feed/'
  //   )
  //     .then(async (result: any) => {
  //       const data = await result.json();
  //       const { items } = data;
  //       let temp = 0;
  //       const list: any[] = [];
  //       items.forEach((row: any) => {
  //         if (temp < 3) {
  //           list.push({
  //             link: row.link.replace(
  //               'https://blogtaxzerone.wpcomstaging.com/',
  //               'https://blog.taxzerone.com/posts/'
  //             ),
  //             imglink: row.link.replace(
  //               'https://blogtaxzerone.wpcomstaging.com/',
  //               'https://blogtaxzerone.wpcomstaging.com/wp-content/uploads/'
  //             ),
  //             title: row.title,
  //             content: row.description,
  //             date: moment(row.pubDate).format('MMM DD, YYYY'),
  //             image: row.imglink,
  //           });
  //           temp += 1;
  //         }
  //       });
  //       //  setBolgItems(list);
  //     })
  //     .catch((error) => {
  //       // eslint-disable-next-line no-console
  //       console.error(error);
  //     });
  // }

  // useEffect(() => {
  //   if (router.isReady) {
  //     fetchData();
  //   }
  // }, [router.isReady]);

  return (
    <>
      {/* {blogItems.map((item: any, index) => (
        <Grid
          item
          xs={12}
          md={4}
          sm={4}
          key={index}
          
          textAlign="left"
        >
          <Box
            sx={{
              border: '1px solid #eaeaea',
              p: 1.5,
              backgroundColor: '#fff',
              pb: { xs: 2, sm: 2 },
              borderRadius: 3,
              minHeight: '100%',
            }}
          >
            <Link
              href={item.link}
              target={'_blank'}
              rel="noreferrer"
              sx={{
                color: '#333',
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              <Box
                sx={{
                  borderRadius: 2,
                  overflow: 'hidden',
                  position: 'relative',
                  mb: 2,
                  '& img': {
                    transform: 'scale(1)',
                    transition: 'all .3s ease',
                    //  objectFit: 'cover',
                    width: '100%',
                    height: 'auto',
                  },
                  '& img:hover': { transform: 'scale(1.11)' },
                }}
              >
                <img
                  src={`${item.imglink}.png`}
                  alt={item.title}
                  width={394}
                  height={251}
                />
              </Box>

              <Typography
                variant="h3"
                sx={{
                  fontSize: { xs: 16, md: 16 },
                  mb: { xs: 1, sm: 1 },
                  fontWeight: 600,
                  minHeight: { xs: 1, sm: 35 },
                }}
              >
                {item.title}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  maxHeight: 'none',
                  overflow: 'hidden',
                  display: '-webkit-box',
                  wordBreak: 'break-word',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  mt: 1,
                }}
              >
                <small
                  style={{
                    fontWeight: 500,
                    fontStyle: 'italic',
                    color: '#7b7b7b',
                  }}
                >
                  {item.date}
                </small>
                <br />
                {item.content}
              </Typography>
            </Link>
          </Box>
        </Grid>
      ))} */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
        }}
      >
        {/* <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Box
          sx={{
            border: '1px solid #eaeaea',
            p: 1.5,
            backgroundColor: '#fff',
            pb: { xs: 2, sm: 2 },
            borderRadius: 3,
            minHeight: '100%',
          }}
        >
          <Link
            href="https://blog.taxzerone.com/posts/taxzerone-now-accepts-form-941-q2-filing-for-the-2026-tax-year/"
            target="_blank"
            sx={{
              color: '#333',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            <Box
              sx={{
                overflow: 'hidden',
                position: 'relative',
                border: '6px solid #42453f !important',
                borderRadius: 3,
                maxHeight: { xs: 183, sm: 134, md: 190, lg: 207 },
                mb: 2,
                '& img': {
                  transform: 'scale(1)',
                  transition: 'all .3s ease',
                  //  objectFit: 'cover',
                  width: '100%',
                  height: 'auto',
                },
                '& img:hover': { transform: 'scale(1.11)' },
              }}
            >
              <Image
                src="https://blog.taxzerone.com/wp-content/uploads/form-941-for-q2-2026-taxyear.png"
                alt="TaxZerone Now Accepts Form 941 Q2 Filing for the 2026 Tax Year"
                width={394}
                height={247}
              />
            </Box>

            <Typography
              variant="h3"
              sx={{
                fontFamily: 'Poppins',
                fontSize: { xs: 16, md: 16 },
                mb: { xs: 1, sm: 1 },
                fontWeight: 600,
                minHeight: { xs: 1, sm: 35 },
              }}
            >
              TaxZerone Now Accepts Form 941 Q2 Filing for the 2026 Tax Year
            </Typography>

            <Typography
              variant="body2"
              sx={{
                fontFamily: 'Poppins',
                maxHeight: 'none',
                overflow: 'hidden',
                display: '-webkit-box',
                wordBreak: 'break-word',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                mt: 1,
              }}
            >
              <small
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  fontStyle: 'italic',
                }}
              >
                July 2, 2026
              </small>
              <br />
              The Form 941 Q2 Filing season is here, and employers should begin
              preparing their payroll tax returns for wages paid between
            </Typography>
          </Link>
        </Box>
      </Grid> */}
        <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
          <Box
            sx={{
              border: '1px solid #eaeaea',
              p: 1.5,
              backgroundColor: '#fff',
              pb: { xs: 2, sm: 2 },
              borderRadius: 3,
              minHeight: '100%',
            }}
          >
            <Link
              href="https://blog.taxzerone.com/posts/taxzerone-accepts-form-2290-filings-for-the-2026-2027-tax-year/"
              target="_blank"
              sx={{
                color: '#333',
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              <Box
                sx={{
                  overflow: 'hidden',
                  position: 'relative',
                  border: '6px solid #42453f !important',
                  borderRadius: 3,
                  maxHeight: { xs: 183, sm: 134, md: 190, lg: 207 },
                  mb: 2,
                  '& img': {
                    transform: 'scale(1)',
                    transition: 'all .3s ease',
                    //  objectFit: 'cover',
                    width: '100%',
                    height: 'auto',
                  },
                  '& img:hover': { transform: 'scale(1.11)' },
                }}
              >
                <Image
                  src="https://blog.taxzerone.com/wp-content/uploads/form-2290-for-2026-27.png"
                  alt="TaxZerone Accepts Form 2290 Filings for the 2026-2027 Tax Year"
                  width={394}
                  height={247}
                />
              </Box>

              <Typography
                variant="h3"
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: { xs: 16, md: 16 },
                  mb: { xs: 1, sm: 1 },
                  fontWeight: 600,
                  minHeight: { xs: 1, sm: 35 },
                }}
              >
                TaxZerone Accepts Form 2290 Filings for the 2026-2027 Tax Year
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontFamily: 'Poppins',
                  maxHeight: 'none',
                  overflow: 'hidden',
                  display: '-webkit-box',
                  wordBreak: 'break-word',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  mt: 1,
                }}
              >
                <small
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 500,
                    fontStyle: 'italic',
                  }}
                >
                  July 1, 2026
                </small>
                <br />
                As the 2026 Heavy Vehicle Use Tax (HVUT) season begins, truck
                owners, owner-operators,
              </Typography>
            </Link>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
          <Box
            sx={{
              border: '1px solid #eaeaea',
              p: 1.5,
              backgroundColor: '#fff',
              pb: { xs: 2, sm: 2 },
              borderRadius: 3,
              minHeight: '100%',
            }}
          >
            <Link
              href="https://blog.taxzerone.com/posts/whats-new-in-form-941-for-2026-key-changes-explained/"
              target="_blank"
              sx={{
                color: '#333',
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              <Box
                sx={{
                  overflow: 'hidden',
                  position: 'relative',
                  border: '6px solid #42453f !important',
                  borderRadius: 3,
                  maxHeight: { xs: 183, sm: 134, md: 190, lg: 207 },
                  mb: 2,
                  '& img': {
                    transform: 'scale(1)',
                    transition: 'all .3s ease',
                    //  objectFit: 'cover',
                    width: '100%',
                    height: 'auto',
                  },
                  '& img:hover': { transform: 'scale(1.11)' },
                }}
              >
                <Image
                  src="https://blog.taxzerone.com/wp-content/uploads/form-941-for-2026-3.png"
                  alt="What’s New in Form 941 for 2026 – Key Changes Explained"
                  width={394}
                  height={247}
                />
              </Box>

              <Typography
                variant="h3"
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: { xs: 16, md: 16 },
                  mb: { xs: 1, sm: 1 },
                  fontWeight: 600,
                  minHeight: { xs: 1, sm: 35 },
                }}
              >
                What’s New in Form 941 for 2026 – Key Changes Explained
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontFamily: 'Poppins',
                  maxHeight: 'none',
                  overflow: 'hidden',
                  display: '-webkit-box',
                  wordBreak: 'break-word',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  mt: 1,
                }}
              >
                <small
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 500,
                    fontStyle: 'italic',
                  }}
                >
                  March 10, 2026
                </small>
                <br />
                The IRS has made a few general updates for the 2026 tax year to
                improve payroll reporting and refund processing.
              </Typography>
            </Link>
          </Box>
        </Grid>
      </Box>
    </>
  );
};

export default BlogContent;
